export default "__VITE_ASSET__Bso2eYwb__"